export enum FilterTypes {
  COUPON_NAME = 'name',
  COUPON_ID = 'ids'
}
